<template>
  <div
    class="relative flex flex-col min-w-0 break-words w-full shadow-lg rounded-lg bg-blueGray-100 border-0"
  >
    <BannerNotification />
    <BlogCreatePageHeader
      :handleCreate="handleCreate"
      :validationStatus="
        validationStatus && componentAllSelected && InstanceNameEntered
      "
    />
    <BlogForm
      pageStatus="create"
      :formData="formData"
      :validationStatus="validationStatus"
      @update:validationStatus="handleUpdateValidationStatus"
    />
  </div>
</template>

<script>
import BlogCreatePageHeader from "@/components/ComponentModule/BlogComponent/BlogCreatePageHeader";
import BannerNotification from "@/components/Shared/Notification/BannerNotification";
import BlogForm from "@/components/ComponentModule/BlogComponent/BlogForm";
import * as Actions from "@/store/actions.type";
import { mapGetters } from "vuex";

export default {
  name: "BlogCreatePage",
  components: { BlogCreatePageHeader, BannerNotification, BlogForm },
  data() {
    return {
      formData: {
        instanceName: "",
        id: "",
        blog: {
          abi_blog_title: "",
          abi_blog_components: "",
          abi_blog_post_id: ""
        },
        components: [
          {
            attributes: {},
            component: "abi_flexible_alignment_text_block",
            componentId: "",
            name: "",
            id: "",
            shouldCreate: "no"
          }
        ]
      },
      validationStatus: true
    };
  },
  computed: {
    shortCode() {
      let shortCodeGroup = this.formData.components.map((item, i) => {
        return `[${item.component} name=${
          this.formData.blog["abi_blog_components"].split(",")[i]
        }]`;
      });
      return shortCodeGroup.join("");
    },
    componentAllSelected() {
      let result;
      this.formData.blog["abi_blog_components"].split(",").forEach((item) => {
        if (item.split("|")[0]) {
          result = true;
        } else {
          result = false;
        }
      });
      return result;
    },
    InstanceNameEntered() {
      if (this.formData.instanceName) {
        return true;
      } else {
        return false;
      }
    },
    ...mapGetters(["getAllComponent", "getRegion", "currentUser", "blogErrors"])
  },
  mounted() {
    if (Object.keys(this.getAllComponent).length) {
      this.formData.id = this.getComponentId("abi_blog");
    }
  },
  watch: {
    getAllComponent() {
      if (Object.keys(this.getAllComponent).length) {
        this.formData.id = this.getComponentId("abi_blog");
      }
    }
  },
  methods: {
    getComponentId(componentName) {
      if (this.getAllComponent.find((item) => item.name === componentName)) {
        return this.getAllComponent.find((item) => item.name === componentName)
          .id;
      } else {
        return null;
      }
    },
    checkFormDataFormat() {
      const componentList = this.formData.blog.abi_blog_components.split(",");
      // *** VALIDATOR: whether the instance is selected ***
      if (componentList.includes("")) {
        this.validationStatus = false;
        this.$store.dispatch(Actions.SET_BLOG_ERRORS, {
          error: "Please select a component instance"
        });
        return;
      } else {
        componentList.forEach((item) => {
          // *** VALIDATOR: whether the component is selected ***
          if (!item.split("|")[0]) {
            this.validationStatus = false;
            this.$store.dispatch(Actions.SET_BLOG_ERRORS, {
              error: "Please select a section component"
            });
            return;
            // *** VALIDATOR: whether the instance name is entered ***
          } else if (!item.split("|")[1].replace("blog_", "")) {
            this.validationStatus = false;
            this.$store.dispatch(Actions.SET_BLOG_ERRORS, {
              error: "Please enter a section name"
            });
            return;
          } else {
            this.validationStatus = true;
            this.$store.dispatch(Actions.CLEAR_BLOG_ERRORS);
          }
        });
      }
    },
    handleUpdateValidationStatus(val) {
      this.validationStatus = val;
    },
    handleCreate() {
      this.checkFormDataFormat();
      if (this.validationStatus) {
        this.$store
          .dispatch(Actions.CREATE_BLOG_COMPONENT_INSTANCE, {
            region: this.getRegion,
            formData: this.formData,
            shortCode: this.shortCode,
            user: this.currentUser?.email
          })
          .then(() => {
            this.$router.push({
              path: `/component/blog-page`
            });
          })
          .catch((error) => {
            console.error("CREATE_BLOG_COMPONENT_INSTANCE failed:", error);
          });
      } else {
        console.log("Validation failed, not dispatching action");
      }
    }
  }
};
</script>
